const baseColors = {
  transparent: 'rgba(0,0,0,0)',
  black: '#000',
  white: '#FFF',
  current: 'currentColor',
  neutral: {
    '-10': 'white',
    '-7': '#EBEBEB',
    '-6': '#E8E8E8',
    '-5': '#CCCCCC',
    '-4': '#B4B4B4',
    '-3': '#787878',
    '-2': '#505050',
    '-1': '#2D2D2D',
    base: '#232323',
  },
  primary: {
    '-6': '#EDEFF4',
    '-5': '#EBECEF',
    '-4': '#D7DBE3',
    '-3': '#C1C5CE',
    '-2': '#454F64',
    '-1': '#182646',
    base: '#0A1633',
    '+1': '#070F22',
  },
  secondary: {
    '-2': '#95CCF7',
    '-1': '#57B3FC',
    base: '#2064FF',
  },
  tertiary: {
    '-4': '#ffdde1',
    base: '#C4162B',
  },
  quaternary: {
    base: '#FFE70C',
  },
};

export default baseColors;
